module.exports = __webpack_public_path__ + "static/media/howItWork5.81759da5.png";